<template>
  <div>
    <v-file-input
      v-bind="{
        ...$attrs,
        multiple: multiple,
        disabled: shouldDisable,
        clearable: !disabled,
      }"
      v-on="{
        ...$listeners,
        click: e => disabled && e.preventDefault(),
      }"
      show-size
      counter
      small-chips
      :clearable="canClearable"
      :label="label"
      :value="files"
      @click:clear="onClear"
    >
      <template v-slot:selection="{ text, file }">
        <v-chip small label close @click.stop="fileClick(file)" @click:close="removeFile(file)">
          {{ text }}
          <span v-if="allowToView(file)" class="ms-1" @click.stop="viewFile(file)">
            <v-icon>
              mdi-eye
            </v-icon>
          </span>
        </v-chip>
      </template>
    </v-file-input>
    <div v-if="shouldShowUploaded" class="d-flex align-center mb-5">
      <span>Уже загруженные:&nbsp;</span>
      <v-chip
        v-for="itemFile in uploadedFiles"
        :key="`uploaded-file-${itemFile.id}`"
        small
        label
        close
        @click.stop="fileClick(itemFile)"
        @click:close="uploadedFileRemove(itemFile)"
      >
        {{ itemFile.name }}
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseInputFile",
  // inheritAttrs: false,

  props: {
    label: { type: String, default: "Файлы" },
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    value: {},
  },

  data() {
    return {
      uploadedFiles: [],
    };
  },

  computed: {
    files() {
      if (!this.value || (Array.isArray(this.value) && !this.value.length)) {
        return this.uploadedFiles || [];
      }

      return Array.isArray(this.value) ? this.value : [this.value];
    },

    shouldDisable() {
      return this.disabled && this.files.length === 0;
    },

    shouldShowUploaded() {
      if (!this.multiple) {
        return false;
      }

      if ((Array.isArray(this.uploadedFiles) && this.uploadedFiles.length === 0) || !this.uploadedFiles) {
        return false;
      }

      if (this.value instanceof File) {
        return true;
      }

      if (Array.isArray(this.value)) {
        return this.value.some(v => v instanceof File);
      }

      return false;
    },

    canClearable() {
      return this.value instanceof File || (Array.isArray(this.value) && this.value.some(v => v instanceof File));
    },
  },

  created() {
    if (this.value) {
      this.uploadedFiles = Array.isArray(this.value) ? this.value : [...this.value];
    }
  },

  methods: {
    allowToView(file) {
      return ["mp4"].includes(file.extension);
    },
    // Слушаем глобальную очистку импута
    onClear() {
      this.$emit("change", this.uploadedFiles);
    },

    fileClick(file) {
      this.$emit("click:file", file);
    },
    viewFile(file) {
      this.$emit("view:file", file);
    },
    removeFile(file) {
      // Удалям добавленный файл в форму которые еще не загружен
      if (file instanceof File) {
        if (this.value instanceof File) {
          this.$emit("change", null);
        } else if (Array.isArray(this.value)) {
          this.$emit(
            "change",
            this.value.filter(fileItem => fileItem.name !== file.name),
          );
        }
      } else {
        this.uploadedFiles = this.uploadedFiles.filter(item => item.id !== file.id);
      }

      this.$emit("file-remove", file);
    },

    uploadedFileRemove(file) {
      this.uploadedFiles = this.uploadedFiles.filter(item => item.id !== file.id);
      this.$emit("file-remove", file);
    },
  },
};
</script>

<style scoped></style>
